import React from 'react';
import classnames from 'classnames';

export interface FileInputProp {
    onChange: (e?: React.ChangeEvent<HTMLInputElement>) => void;
    acceptedFileTypes: string;
    title: JSX.Element | string;
    className?: string | null;
    inputClassName?: string | null;
    type?: 'upload' | 'default';
    disabled?: boolean;
    multiple?: boolean;
    ref?: React.Ref<HTMLInputElement>;
}

export const FileInput = (props: FileInputProp): JSX.Element => {
    const { onChange, className, inputClassName, acceptedFileTypes, title, type = 'upload', disabled, multiple = false, ref } = props;

    const getDataAttributes = () => Object.keys(props).reduce((acc, key) => {
        if (key.startsWith('data-')) {
            acc[key] = props[key];
        }

        return acc;
    }, {});

    const typeClassName = type === 'default' ? 'default-button' : 'upload-button';
    const typeClassNameDisabled = `${typeClassName}--disabled`;

    const renderedTitle: React.ReactNode = title;

    return (
        <label
            className={classnames(
                typeClassName,
                disabled && typeClassNameDisabled,
                className,
            )}
        >
            {renderedTitle}
            <input
                multiple={multiple}
                style={{ display: 'none' }}
                accept={acceptedFileTypes}
                type='file'
                onChange={onChange}
                className={inputClassName}
                ref={ref}
                {...getDataAttributes()}
                onDragOver={e => {
                    e.preventDefault();
                    e.stopPropagation();
                }}
                onDrop={e => {
                    e.preventDefault();
                    e.stopPropagation();
                }}
            />
        </label>
    );
};